import * as React from 'react';
import Table from '../../../theme/components/table/Table';
import {Button, Card, Col, Container, Row} from 'reactstrap';
import {lazyInject, TYPES} from '../../../utils/inversify-config';
import MeepoServiceClient from '../../../middleware/meepo-client';
import {Map, Marker, Polyline, Popup, TileLayer} from 'react-leaflet';
import {latLng, latLngBounds} from 'leaflet';
import {FirebaseClient} from '../../../middleware/firebase';
import ArrowLeftIcon from 'mdi-react/ArrowLeftIcon';
import {GeoPoint} from 'firebase/firestore';
import {withRouter} from 'react-router-dom';
import {Store} from 'react-redux';
import MeepoState from '../../../reduxstore/meepo-state';
import {error} from '../../../utils/notification-actions';
import {localCurrency} from '../../../utils/number-utils';
import {camionIcon, divIcon, icon} from '../../common/icon';
import {colorByDistancia, colorByEstado, distancia, isCoordValid, isoStrToAMPM} from '../../../utils/utils';
import Filtros from './filtros';
import {IComprobante, IResumenDiario} from '../../../utils/models';
import * as qs from 'query-string';
import * as moment from 'moment';

interface IState {
    rutaId: string;
    comprobantes: IComprobante[];
    gpsPoints: latLng[];
    resumen?: IResumenDiario;
    bounds?: latLng[];
    envioLineas: any[];
    firstLoad: boolean;
    showDistancia: boolean;
    showAceptable: boolean;
    showRegular: boolean;
    showDeficiente: boolean;
    showEstados: boolean;
    showPendientes: boolean;
    showAceptados: boolean;
    showRechazados: boolean;
    showParciales: boolean;
    showRuta: boolean;
    showEnvio: boolean;
    marcadorMovil?: any;
    fecha?: string;
}

class MapaView extends React.PureComponent<any, IState> {

    @lazyInject(TYPES.MEEPO_SERVICE)
    public apiClient: MeepoServiceClient;

    @lazyInject(TYPES.FIREBASE)
    public firebase: FirebaseClient;

    @lazyInject(TYPES.REDUX_STORE)
    public store: Store<MeepoState>;

    private readonly map;

    private readonly tileUrl = `https://api.mapbox.com/styles/v1/mapbox/streets-v10/tiles/256/{z}/{x}/{y}?access_token=${process.env.REACT_APP_MAP_BOX_KEY}`;

    constructor(props) {
        super(props);
        const rutaId = props.match.params.rutaId;
        let fecha;
        if (props.location.search) {
            fecha = qs.parse(props.location.search).fecha
        }
        this.state = {
            rutaId,
            comprobantes: [],
            gpsPoints: [],
            envioLineas: [],
            firstLoad: true,
            showDistancia: false,
            showAceptable: true,
            showRegular: true,
            showDeficiente: true,
            showEstados: true,
            showPendientes: true,
            showAceptados: true,
            showRechazados: true,
            showParciales: true,
            showRuta: true,
            showEnvio: false,
            fecha
        };
        this.map = React.createRef();
    }

    public componentDidMount() {
        const rutaId = this.props.match.params.rutaId;
        let fecha;
        if (this.props.location.search) {
            fecha = qs.parse(this.props.location.search).fecha
        }
        this.getGPSPoints(rutaId);
        this.obtenerComprobantesPorRuta(rutaId, fecha);
        this.getResumen(rutaId, fecha);

        setInterval(async () => {
            this.obtenerComprobantesPorRuta(rutaId, fecha);
            this.getResumen(rutaId, fecha);
        }, 120000);

    }

    public componentWillUnmount() {
        const {rutaId} = this.props;
        const unsubscribe = this.firebase.getDb().collection(`seguimiento/${rutaId}/points`)
            .onSnapshot(() => {
                /*EMPTY BLOCK*/
            });
        unsubscribe();
    }

    private obtenerComprobantesPorRuta = async (rutaId: string, fecha?: string) => {
        try {
            const comprobanteResp = await this.apiClient.obtenerComprobantesPorRuta(rutaId, fecha);
            this.setState({comprobantes: comprobanteResp});
            if (this.state.firstLoad) {
                this.calcularBounds(comprobanteResp);
            }
        } catch (ex) {
            this.store.dispatch(error('Error', 'Error al obtener comprobantes'));
        }
    };

    private calcularBounds = (comps: IComprobante[]) => {
        const latLngPoints = [] as latLng[];
        comps.forEach((com) => {
            if (isCoordValid(com.cliente.latitud) && isCoordValid(com.cliente.longitud)) {
                const point = latLng(Number(com.cliente.latitud), Number(com.cliente.longitud));
                latLngPoints.push(point)
            }
        });
        const bounds = latLngPoints.length > 0 ? latLngBounds(latLngPoints) : latLngBounds(latLng(-12.0692936, -76.9876994), latLng(-12.0692936, -76.9876995));
        this.setState({firstLoad: false, bounds});
    };

    private getGPSPoints = async (rutaId: string) => {
        try {
            const rutaRef = this.firebase.getDb().collection(`seguimiento/${rutaId}/points`);
            let startDate;
            let endDate;
            if (this.state.fecha) {
                startDate = new Date(moment(this.state.fecha, 'YYYY-MM-DD').toDate().setHours(0, 0, 0, 0));
                endDate = new Date(moment(this.state.fecha, 'YYYY-MM-DD').toDate().setHours(23, 59, 59, 59));
            } else {
                startDate = new Date(new Date().setHours(0, 0, 0, 0));
                endDate = new Date(new Date().setHours(23, 59, 59, 59));
            }
            const query = rutaRef.where('fecha', '>=', startDate)
                .where('fecha', '<=', endDate).orderBy('fecha', 'asc');
            let lastPoint;
            let first = true;
            query.onSnapshot((snapshot) => {
                const oldRoutes = [...this.state.gpsPoints];
                snapshot.docChanges().forEach((change) => {
                    if (change.type === 'added') {
                        if (change.doc.data().point) {
                            const geoPoint: GeoPoint = change.doc.data().point;
                            if (first) {
                                first = false;
                                oldRoutes.push(latLng(geoPoint.latitude, geoPoint.longitude));
                                lastPoint = {lat: geoPoint.latitude, lon: geoPoint.longitude};
                            }
                            if (lastPoint && distancia(lastPoint.lat, lastPoint.lon, geoPoint.latitude,
                                    geoPoint.longitude, 'MM') <= 3500) {
                                oldRoutes.push(latLng(geoPoint.latitude, geoPoint.longitude));
                                lastPoint = {lat: geoPoint.latitude, lon: geoPoint.longitude};
                            }
                        }
                    }
                });
                const marcadorMovil = oldRoutes.length > 0 ? oldRoutes[oldRoutes.length - 1] : null;
                this.setState({gpsPoints: oldRoutes, marcadorMovil});
            });
        } catch (ex) {
            this.store.dispatch(error('Error', 'Error al obtener puntos de localización'));
        }
    };

    private getResumen = async (rutaId: string, fecha?: string) => {
        try {
            const resumenResp = await this.apiClient.obtenerResumenPorRuta(rutaId, fecha);
            this.setState({resumen: resumenResp});
        } catch (ex) {
            this.store.dispatch(error('Error', 'Error al obtener resumen por ruta'));
        }
    };

    private isEstadoValido = (estado: string) => {
        if ((!this.state.showPendientes && estado === 'PENDIENTE') ||
            (!this.state.showAceptados && estado === 'ACEPTADO') ||
            (!this.state.showRechazados && estado === 'RECHAZADO') ||
            (!this.state.showParciales && estado === 'PARCIAL')) {
            return false;
        } else {
            return true;
        }
    };

    private isDistanciaValida = (comprobante: IComprobante) => {
        if (comprobante && isCoordValid(comprobante.updated_longitud)
            && isCoordValid(comprobante.updated_latitud) && isCoordValid(comprobante.cliente.latitud) && isCoordValid(comprobante.cliente.longitud)) {
            const dist = distancia(Number(comprobante.cliente.latitud), Number(comprobante.cliente.longitud),
                Number(comprobante.updated_latitud), Number(comprobante.updated_longitud), 'MM');

            if ((!this.state.showDeficiente && colorByDistancia(dist) === 'deficiente' ||
                    !this.state.showRegular && colorByDistancia(dist) === 'regular') ||
                (!this.state.showAceptable && colorByDistancia(dist) === 'aceptable')) {
                return false;
            } else {
                return true;
            }
        } else {
            return false;
        }
    };

    private get clientesMarkers() {
        const content: any[] = [];
        const latLngPoints = [] as latLng[];
        this.state.comprobantes.forEach((comp, idx) => {
            if (!isCoordValid(comp.cliente.latitud) || !isCoordValid(comp.cliente.longitud)) {
                return;
            }
            if (this.state.showEstados && !this.isEstadoValido(comp.estado)) {
                return;
            }
            if (this.state.showDistancia && !this.isDistanciaValida(comp)) {
                return;
            }
            const point = latLng(Number(comp.cliente.latitud), Number(comp.cliente.longitud));
            latLngPoints.push(point);
            content.push(
                <Marker key={`mk-${idx}`} position={point}
                        icon={icon(this.state.showEstados ? colorByEstado(comp.estado)
                            : colorByDistancia(distancia(Number(comp.cliente.latitud), Number(comp.cliente.longitud),
                                Number(comp.updated_latitud), Number(comp.updated_longitud), 'MM')))}
                        onClick={() => {
                            this.onClickMarker(comp)
                        }}>
                    <Popup>
                        <Table responsive={true}>
                            <tbody>
                            <tr>
                                <td colSpan={2}>{comp.numero_comprobante}</td>
                            </tr>
                            <tr>
                                <td>{comp.cliente.cliente_id}</td>
                                <td>{comp.cliente.razon_social}</td>
                            </tr>
                            <tr>
                                <td colSpan={2}>{comp.cliente.direccion}</td>
                            </tr>
                            <tr>
                                <td colSpan={2}>Telfs. {comp.cliente.telefono_principal} - {comp.cliente.telefono_secundario}</td>
                            </tr>
                            <tr>
                                <td colSpan={2}>Superv. Telf. {comp.cliente.supervisor_celular}</td>
                            </tr>
                            <tr>
                                <td>{isoStrToAMPM(comp.updated_at)}</td>
                                <td>S/ {localCurrency(comp.monto)}</td>
                            </tr>
                            <tr>
                                <td colSpan={2}>{comp.estado} {comp.motivo_rechazo ? ' - ' + comp.motivo_rechazo.descripcion : null}</td>
                            </tr>
                            </tbody>
                        </Table>
                    </Popup>
                </Marker>
            )
        });

        return content;
    }

    private onClickMarker(comprobante: IComprobante) {
        if (!this.state.showEnvio && comprobante && isCoordValid(comprobante.updated_longitud)
            && isCoordValid(comprobante.updated_latitud) && isCoordValid(comprobante.cliente.latitud) && isCoordValid(comprobante.cliente.longitud)) {
            this.setState({
                envioLineas: [{
                    comprobante,
                    fin: latLng(Number(comprobante.updated_latitud), Number(comprobante.updated_longitud)),
                    inicio: latLng(Number(comprobante.cliente.latitud), Number(comprobante.cliente.longitud))
                }]
            })
        }
    }

    private onEnvioToggle(toggle: boolean) {
        const envioLineas = [] as any;
        if (toggle) {
            this.state.comprobantes.forEach((comprobante) => {
                if (comprobante && isCoordValid(comprobante.updated_longitud)
                    && isCoordValid(comprobante.updated_latitud) && isCoordValid(comprobante.cliente.latitud) && isCoordValid(comprobante.cliente.longitud)) {
                    envioLineas.push({
                        fin: latLng(Number(comprobante.updated_latitud), Number(comprobante.updated_longitud)),
                        inicio: latLng(Number(comprobante.cliente.latitud), Number(comprobante.cliente.longitud)),
                        comprobante
                    })
                }
            });
        }
        this.setState({envioLineas});
    }

    private get envioMarkers() {
        const content: any[] = [];
        this.state.comprobantes.forEach((comp, idx) => {
            if (!comp.updated_latitud ||
                Number(comp.updated_latitud) === 0 ||
                !comp.updated_longitud ||
                Number(comp.updated_longitud) === 0) {
                return;
            }
            const point = latLng(Number(comp.updated_latitud), Number(comp.updated_longitud));
            content.push(<Marker key={`mk-${idx}`} position={point}
                                 onClick={() => {
                                     this.onClickMarker(comp)
                                 }}
                                 icon={divIcon(`<div/>`, `delivery marker`, [10, 10])}/>)
        });
        return content;
    }

    private get envioLineas() {
        const content: any[] = [];
        this.state.envioLineas.forEach((puntos, idx) => {
            if (this.state.showEstados && !this.isEstadoValido(puntos.comprobante.estado)) {
                return;
            }
            if (this.state.showDistancia && !this.isDistanciaValida(puntos.comprobante)) {
                return;
            }
            content.push(<Polyline key={`pol-${idx}`} positions={[puntos.inicio, puntos.fin]}
                                   color='black'
                                   weight={2}/>)
        });
        return content;
    }

    private get resumen() {
        const {resumen} = this.state;
        let fecha;
        if(this.state.fecha){
            fecha = moment(this.state.fecha, 'YYYY-MM-DD').format('DD/MM/YYYY');
        }
        if (resumen) {
            return <div className='cabecera'>
                <p className='titulo'>{resumen.ruta.descripcion}</p>
                <p className='fecha'>{fecha}</p>
                <p><span>Cartera</span><span
                    style={{float: 'right'}}>{resumen.cartera_total}</span>
                </p>
                <p><span>Entregados</span><span
                    style={{float: 'right'}}>{resumen.aceptados}</span>
                </p>
                <p><span>Rechazados</span><span
                    style={{float: 'right'}}>{resumen.rechazados}</span>
                </p>
                <p><span>No Reportados</span><span
                    style={{float: 'right'}}>{resumen.pendientes}</span>
                </p>
                <p className='footer'>Monto por liquidar</p>
                <p className='monto'>S/ {localCurrency(resumen.monto_aceptado)}</p>
            </div>;
        }
        return null;
    }

    private get marcadorMovil() {
        const {marcadorMovil} = this.state;
        if (marcadorMovil) {
            return <Marker position={marcadorMovil}
                           icon={camionIcon}/>
        }
        return null;
    }

    private returnButton = () => {
        this.props.history.push(`/home?fecha=${this.state.fecha}`)
    };

    private toggleFiltros = (check: string) => {
        if (check === 'distancia') {
            this.setState({showDistancia: !this.state.showDistancia, showEstados: !this.state.showEstados})
        } else if (check === 'aceptable') {
            this.setState({showAceptable: !this.state.showAceptable});
        } else if (check === 'regular') {
            this.setState({showRegular: !this.state.showRegular})
        } else if (check === 'deficiente') {
            this.onEnvioToggle(this.state.showEnvio);
            this.setState({showDeficiente: !this.state.showDeficiente})
        } else if (check === 'estados') {
            this.setState({showDistancia: !this.state.showDistancia, showEstados: !this.state.showEstados})
        } else if (check === 'pendientes') {
            this.setState({showPendientes: !this.state.showPendientes})
        } else if (check === 'aceptados') {
            this.setState({showAceptados: !this.state.showAceptados})
        } else if (check === 'rechazados') {
            this.setState({showRechazados: !this.state.showRechazados})
        } else if (check === 'parciales') {
            this.setState({showParciales: !this.state.showParciales})
        } else if (check === 'ruta') {
            this.setState({showRuta: !this.state.showRuta})
        } else if (check === 'envio') {
            this.onEnvioToggle(!this.state.showEnvio);
            this.setState({showEnvio: !this.state.showEnvio})
        }
    };

    public render() {
        return (
            <Container className='dashboard'>
                <Filtros
                    distancia={this.state.showDistancia}
                    aceptable={this.state.showAceptable}
                    regular={this.state.showRegular}
                    deficiente={this.state.showDeficiente}
                    estados={this.state.showEstados}
                    pendientes={this.state.showPendientes}
                    aceptados={this.state.showAceptados}
                    rechazados={this.state.showRechazados}
                    parciales={this.state.showParciales}
                    ruta={this.state.showRuta}
                    envio={this.state.showEnvio}
                    toggle={this.toggleFiltros}/>
                <Row>
                    <Col md={11}>
                        <h3 className='page-title'>Mapa por ruta</h3>
                    </Col>
                    <Col md={1}>
                        <Button className='icon' onClick={this.returnButton} outline={true}><p>
                            <ArrowLeftIcon/> Volver</p></Button>
                    </Col>
                    <Col md={12} lg={12} style={{height: '85vh'}}>
                        <Card>
                            <Map
                                className='seguimiento-map'
                                maxZoom={19}
                                zoom={10}
                                minZoom={7}
                                ref={this.map}
                                bounds={this.state.bounds}>
                                {this.resumen}
                                <TileLayer
                                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                    url={this.tileUrl}
                                />
                                {this.marcadorMovil}
                                {this.clientesMarkers}
                                {this.envioMarkers}
                                {this.envioLineas}
                                {this.state.showRuta ?
                                    <Polyline positions={this.state.gpsPoints} color='#1565C0'/> : null}
                            </Map>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default withRouter(MapaView);


// WEBPACK FOOTER //
// ./src/components/pages/mapa/mapa.tsx